import {ChevronDown} from "lucide-react";

export default function SidebarChevron() {
  return <ChevronDown className="w-5 h-3 text-gray-400" />;
}
